module.exports = __webpack_public_path__ + "img/allegro_dark_brown1.66db7ed9.jpg";